import { Box, type BoxProps, HStack, type StackProps } from '@chakra-ui/react'
import Link from 'next/link'
import { GrandImage } from 'ui'
import granditudeLogo from './granditude_logo.png'

type FooterGranditudeSignProps = StackProps & {
  textProps?: BoxProps
}

export const FooterGranditudeSign = ({ textProps, ...props }: FooterGranditudeSignProps) => {
  return (
    <HStack alignItems="center" gap={4} {...props}>
      <Box opacity="0.7" fontSize={['xs', 'sm']} {...textProps}>
        Powered by
      </Box>
      <Link href="https://granditude.com" target="_blank">
        <GrandImage maxW="100px" src={granditudeLogo} alt="Granditude" sizes="100px" />
      </Link>
    </HStack>
  )
}
